import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "payment-services-extension-mutations"
    }}>{`Payment Services extension mutations`}</h1>
    <p>{`The mutations described in this section allow you to create, update, and delete payment-related data with the Payment Services extension.`}</p>
    <p>{`If you have installed `}<a parentName="p" {...{
        "href": "https://commercemarketplace.adobe.com/magento-payment-services.html"
      }}>{`Payment Services for Adobe Commerce`}</a>{` 2.3.0 or higher, you can use the following mutations during checkout:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "../mutations/create-payment-order.md"
          }}><inlineCode parentName="a">{`createPaymentOrder`}</inlineCode></a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "../mutations/sync-payment-order.md"
          }}><inlineCode parentName="a">{`syncPaymentOrder`}</inlineCode></a></p>
      </li>
    </ul>
    <p>{`If you have installed `}<a parentName="p" {...{
        "href": "https://commercemarketplace.adobe.com/magento-payment-services.html"
      }}>{`Payment Services for Adobe Commerce`}</a>{` 2.10.0 or higher, you can use the following mutations to vault a credit card without a purchase:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "../mutations/create-vault-card-setup-token.md"
          }}><inlineCode parentName="a">{`createVaultCardSetupToken`}</inlineCode></a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "../mutations/create-vault-card-payment-token.md"
          }}><inlineCode parentName="a">{`createVaultCardPaymentToken`}</inlineCode></a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      